import React from "react";

const TermsConditions = () => {
  return (
    <div className="container mx-auto p-6 mt-48 text-gray-800">
      <h1 className="text-3xl font-bold mb-4">Terms & Conditions</h1>
      <section className="mb-6">
        <h2 className="text-xl font-semibold">1. Introduction</h2>
        <p>
          Welcome to KFM, a product of Aqua Fanatics Tech Private Limited ("Company", "we", "our", "us")! These Terms of Service ("Terms") govern your use of our website located at saiaquapets.com (the "Service"), operated by Aqua Fanatics Tech Private Limited.
        </p>
        <p>
          Our Privacy Policy also governs your use of our Service and explains how we collect, safeguard, and disclose information resulting from your use of our web pages.
        </p>
        <p>
          By accessing and using our Service, you acknowledge that you have read and understood these Terms and our Privacy Policy (collectively, "Agreements") and agree to be bound by them.
        </p>
        <p>
          If you do not agree with the Agreements, you may not use the Service. However, please reach out to us at support@saiaquapets.com, and we will try to find a solution.
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold">2. Communications</h2>
        <p>
          By using our Service, you agree to subscribe to newsletters, marketing, or promotional materials that we may send. However, you can opt-out of these communications by following the unsubscribe link or emailing support@saiaquapets.com.
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold">3. Purchases</h2>
        <p>
          If you wish to purchase any product or service available on our Service ("Purchase"), you may be required to provide information such as your credit or debit card details, billing address, and shipping information.
        </p>
        <p>
          By making a Purchase, you represent and warrant that:
        </p>
        <ul className="list-disc ml-6">
          <li>You have the legal right to use the payment method provided.</li>
          <li>The information you provide is accurate and complete.</li>
        </ul>
        <p>
          We may use third-party services for payment processing. By submitting your information, you authorize us to provide your details to these third parties in accordance with our Privacy Policy.
        </p>
        <p>
          We reserve the right to refuse or cancel your order at any time due to reasons including, but not limited to:
        </p>
        <ul className="list-disc ml-6">
          <li>Product or service unavailability</li>
          <li>Errors in pricing or description</li>
          <li>Suspected fraudulent transactions</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold">4. Contests, Sweepstakes, and Promotions</h2>
        <p>
          Any contests, sweepstakes, or promotions (collectively, "Promotions") available through the Service will be governed by separate rules. Please review the applicable rules along with these Terms before participating.
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold">5. Refunds</h2>
        <p>
          Refunds for purchases will be issued within 15 days of the original purchase date.
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold">6. Content</h2>
        <p>
          Our Service allows users to post, link, store, share, and otherwise make available certain content ("Content"). Users are responsible for ensuring that their Content does not violate any rights, including privacy, copyright, or trademark rights.
        </p>
        <p>
          By posting Content on our Service, you grant us a non-exclusive right to use, modify, publicly perform, display, reproduce, and distribute such Content.
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold">7. Prohibited Uses</h2>
        <ul className="list-disc ml-6">
          <li>Violating national or international laws.</li>
          <li>Exploiting or harming minors.</li>
          <li>Impersonating any person or entity.</li>
          <li>Transmitting spam, malware, or unauthorized advertisements.</li>
          <li>Engaging in activities that disrupt or interfere with the Service.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold">8. Analytics</h2>
        <p>
          We may use third-party services to monitor and analyze usage of our Service.
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold">9. Governing Law</h2>
        <p>
          These Terms shall be governed by the laws of India. Any disputes arising from these Terms will be subject to the exclusive jurisdiction of the courts in India.
        </p>
      </section>
      <p>
        For any questions, contact us at <a href="mailto:support@saiaquapets.com" className="text-blue-600">support@saiaquapets.com</a>.
      </p>
    </div>
  );
};

export default TermsConditions;
